(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.controller('LightboxProductModal', ['$scope', '$rootScope', '$uibModalInstance', 'product', 'store', '$uibModal', function($scope, $rootScope, $uibModalInstance, product, store, $uibModal) {

        angular.extend($scope, {

            // vars
            product: trimOutUnselectedAttributes(product),
            // customerProductPrice: product.basePrice,
            customerProduct:{},

            store: store,

            //methods

            init: function() {

                $scope.activeImage = product.featuredImage.productImage;

                $scope.customerProduct = {
                    basePrice: product.basePrice,
                    price: product.basePrice,
                    name: product.name,
                    quantity: 1
                }
            },

            updateProductPrice: function() {

                let productPrice = parseFloat(product.basePrice);

                _.forEach( $scope.customerProduct.properties, function(value, key){

                    if(key === 'customName' || key === 'customNumber'){
                        if(_.isEmpty(value.name)){
                            productPrice = productPrice;
                        } else {
                            if(key === 'customName'){
                                if(product.customizationNameCost){
                                    productPrice = productPrice + parseFloat(product.customizationNameCost);
                                } else {
                                    productPrice = productPrice; // customizationNameCost = 0
                                }
                            } else {
                                if(product.customizationNumberCost){
                                    productPrice = productPrice + parseFloat(product.customizationNumberCost);
                                } else {
                                    productPrice = productPrice; // customizationNumberCost = 0
                                }
                            }
                        }
                    } else {
                        if(value.price !== 0){
                            productPrice = productPrice + parseFloat(value.price);
                        } else {
                            productPrice = productPrice; // product.price = 0
                        }
                    }
                });

                productPrice = productPrice * $scope.customerProduct.quantity;

                $scope.customerProduct.price = productPrice;
            },


            thumbnailSwitch: function(productImage) {

                $scope.activeImage = productImage;

            },

            thumbnailLighbox: function() {

                $uibModal.open({
                    animation: true,
                    windowTemplateUrl: 'directives/externalStore/fullScreenModalWindowTemplate.html',
                    templateUrl:'directives/externalStore/fullScreenImageModal.html',
                    controller: function($scope, $uibModalInstance, activeImage, $timeout) {

                        $scope.activeImage = activeImage;

                        $scope.maxHeight = window.innerHeight - 50;

                        $scope.close = function () {
                            $uibModalInstance.dismiss('cancel');
                        };

                    },
                    size: 'lg',
                    resolve: {
                        activeImage: function() {
                            return $scope.activeImage
                        }
                    }
                });

            },

            viewSizeChart: function() {
                $uibModal.open({
                    animation: true,
                    windowTemplateUrl: 'directives/externalStore/fullScreenModalWindowTemplate.html',
                    templateUrl:'directives/externalStore/fullScreenImageModal.html',
                    controller: function($scope, $uibModalInstance, activeImage, $timeout) {

                        $scope.activeImage = activeImage;

                        $scope.maxHeight = window.innerHeight - 50;

                        $scope.close = function () {
                            $uibModalInstance.dismiss('cancel');
                        };

                    },
                    size: 'lg',
                    resolve: {
                        activeImage: function() {
                            return product.fitGuide.file
                        }
                    }
                });
            },

            prettyAttributeInOption: function(attribute) {

                let costString = '';

                if(attribute.price === 0){
                    // whatever the attribute is, its not changing the price
                    // nothing happening here, move on

                } else {

                    // we have a negative or positibe price increase
                    costString = ' [$ ' + attribute.price + ']';

                }


                return attribute.name + costString;

            },

            addToCart: function () {

                $scope.customerProduct.thumbnail = product.featuredImage.productImage; // we are lacking the product image so we are manually adding it.

                $rootScope.$emit('cart.product.added', $scope.customerProduct);

                // console.log('addToCart', $scope.customerProduct);

                $uibModalInstance.close($scope.customerProduct);

            },

            cancel: function () {
                $uibModalInstance.dismiss('cancel');
            },

            test: function() {
                // console.log('customerProduct', $scope.customerProduct);
            }

        });

        $scope.init();

        function trimOutUnselectedAttributes(product) {

            let trimmedProductProperties = [];

            _.forEach(product.properties, (property) => {

                if(_.find(property.attributes, {'selected': true})){

                    trimmedProductProperties.push(property)

                }

            });

            product.properties = trimmedProductProperties;

            return product;

        };

    }]);

})();
